module.exports = __webpack_public_path__ + "img/category_history__and__culture.545cae7.png";